var map = {
	"./bat.webp": 1806,
	"./bigfoot.webp": 3419,
	"./cave bear.webp": 1198,
	"./cave naga.webp": 3216,
	"./cerberus.webp": 9081,
	"./chimera.webp": 5232,
	"./cyclops.webp": 4268,
	"./desert hound.webp": 2846,
	"./desert owl.webp": 7421,
	"./efreeti.webp": 9482,
	"./electric eel.webp": 9680,
	"./fire dragon.webp": 1661,
	"./fire gargoyle.webp": 9248,
	"./fire golem.webp": 8075,
	"./giant crab.webp": 2461,
	"./giant rat.webp": 739,
	"./giant scorpion.webp": 1671,
	"./giant spider.webp": 6269,
	"./goblin.webp": 4585,
	"./gorgon.webp": 2458,
	"./hydra.webp": 8345,
	"./kraken.webp": 6021,
	"./leviathan.webp": 581,
	"./light devourer.webp": 2393,
	"./marine behemoth.webp": 300,
	"./medusa.webp": 4620,
	"./mine howler.webp": 7006,
	"./mine specter.webp": 5380,
	"./miner skeleton.webp": 6538,
	"./minotaur.webp": 9722,
	"./mothman.webp": 8238,
	"./mutant octopus.webp": 3803,
	"./oasis specter.webp": 3421,
	"./orc king.webp": 5218,
	"./orc.webp": 4369,
	"./outlaw.webp": 7400,
	"./phoenix.webp": 8585,
	"./rock gargoyle.webp": 2994,
	"./salt golem.webp": 1716,
	"./sand serpent.webp": 6142,
	"./sasquatch.webp": 8947,
	"./sea dragon.webp": 3736,
	"./sea vermin.webp": 6932,
	"./servant.webp": 8052,
	"./siren.webp": 7360,
	"./skeleton.webp": 2062,
	"./soul devourer.webp": 2870,
	"./stone golem.webp": 7050,
	"./storm spirit.webp": 3848,
	"./sun dragon.webp": 7577,
	"./troll.webp": 9491,
	"./vampire.webp": 2085,
	"./wendigo.webp": 1813,
	"./wind gargoyle.webp": 5811,
	"./winged serpent.webp": 9272,
	"./witch.webp": 9650,
	"./wolf.webp": 4282,
	"./yeti.webp": 5199,
	"./zombie king.webp": 6838,
	"./zombie.webp": 8523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3971;